import { RootContainer } from '../../../core/root_container';
import { applyCarouselStyle } from '../../../core/views/common/carousel_util';
import { VariationJsEnv } from '../../models/variation_js_env';
import {
  RrBodyVariationsUpper,
  RrBodyVariationsLower,
} from './rr_body';
import { Env } from '../../../core/env';
import { isSoloare } from '../../../core/models/js_env';

export class RrContainer extends RootContainer<VariationJsEnv> {
  constructor(model: VariationJsEnv) {
    super();

    this.mount(RrBodyVariationsUpper, model.rrAreaProfileVariationsUpper.placementName);
    this.mount(RrBodyVariationsLower, model.rrAreaProfileVariationsLower.placementName);

    // 初回描画
    this.update(model);

    const placementNameList = isSoloare(Env.SITE_TYPE)
      ? [
          model.rrAreaProfileVariationsUpper.placementName,
          model.rrAreaProfileVariationsLower.placementName
        ]
      : [
          model.rrAreaProfileVariationsUpper.placementName,
          model.rrAreaProfileVariationsLower.placementName,
        ];

    const carouselIdList = placementNameList.map((placementName) => placementName + '-carousel');
    applyCarouselStyle(carouselIdList);

    // (IE11の対応のために追加)
    // RRレコメンドエリアがフィルタを隠すことがあるためz-indexを設定する
    placementNameList.forEach((placementName) => {
      const rrAreaDom = document.getElementById(placementName);
      if (rrAreaDom) rrAreaDom.style.zIndex = '0';
    });

    this.switchInputField(placementNameList);
  }

  /// RRレコメンドエリアの数量を変えた時(10+)の入力欄切り替え
  private switchInputField(placementNameList: string[]) {
    const WindowAddcart = window._addcart;
    placementNameList.forEach(placementName => {
      const target = document.getElementById(placementName);
      if (target) new WindowAddcart(target); // NOSONAR
    });
  }
}
